import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import PdsMeta from 'src/components/meta/PdsMeta';
import Spacing from 'src/design/styleguide/spacing/Spacing';
import { fsgDirectUrl, pdsDirectUrl, tmdDirectUrl } from 'src/utils/pageUrls';
import PropertyStatus from 'scripts/constants/PropertyStatus';
import { renderCode } from 'src/settings/properties';
import { propertiesSelector } from 'scripts/redux/selectors/properties';
import { fetchProperties } from 'scripts/redux/actions/properties';
import Paragraph from 'src/design/styleguide/Paragraph';

const mapStateToProps = (state) => ({
  ...propertiesSelector(state),
});

const mapDispatchToProps = {
  fetchProperties,
};

@connect(mapStateToProps, mapDispatchToProps)
export default class PdsPage extends Component {
  static propTypes = {
    properties: PropTypes.array.isRequired,
    fetchProperties: PropTypes.func.isRequired,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.fetchProperties();
  }
  render() {
    const { properties } = this.props;

    return (
      <div className="pds-page">
        <PdsMeta />
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1 smsf-page">
              <h1>Financial Services Guide</h1>
              <Paragraph className="text-center">
                The Financial Services Guide can be downloaded as a PDF by
                clicking on the link below.
              </Paragraph>
            </div>
            <Spacing top="normal">
              <div className="col-md-10 col-md-offset-1 text-center">
                <Link
                  to={fsgDirectUrl()}
                  target="_blank"
                  className="doc-download"
                >
                  <div className="button orange-button right-arrow-button">
                    DOWNLOAD FINANCIAL SERVICES GUIDE
                  </div>
                </Link>
              </div>
            </Spacing>
          </div>
          <div className="row">
            <div className="col-md-10 col-md-offset-1 smsf-page">
              <h1>Target Market Determination </h1>
              <Paragraph className="text-center">
                The Target Market Determination can be downloaded as a PDF by
                clicking on the link below.
              </Paragraph>
            </div>
            <Spacing top="normal">
              <div className="col-md-10 col-md-offset-1 text-center">
                <Link
                  to={tmdDirectUrl()}
                  target="_blank"
                  className="doc-download"
                >
                  <div className="button orange-button right-arrow-button">
                    DOWNLOAD TARGET MARKET DETERMINATION
                  </div>
                </Link>
              </div>
            </Spacing>
          </div>
          <div className="row">
            <div className="col-md-10 col-md-offset-1 smsf-page">
              <h1>Product Disclosure Statement</h1>
              <Paragraph className="text-center">
                The Product Disclosure Statement can be downloaded as a PDF by
                clicking on the link below. Before making any decision in
                relation to BrickX or any product offered by BrickX you should
                read the Product Disclosure Statement (PDS), Additional PDS for
                CLN01 and consider whether it is right for you. You should also
                review the information set out in the RG46 Schedule before
                making an investment decision.
              </Paragraph>
              <Paragraph className="text-center">
                BrickX products are issued by BrickX Financial Services Limited
                (ABN 67 616 118 088) (AFSL 494878)
              </Paragraph>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-10 col-md-offset-1 text-center">
              <Link
                to={pdsDirectUrl()}
                target="_blank"
                className="doc-download"
              >
                <div className="button orange-button right-arrow-button">
                  DOWNLOAD PRODUCT DISCLOSURE STATEMENT
                </div>
              </Link>
            </div>
          </div>
          <br />
          {properties
            .filter(
              (property) =>
                property.visibilityState === 'Public' &&
                new Date(property.settlementDate) >= new Date('2020-01-01') &&
                property.propertyStatus !== PropertyStatus.MARKET_CLOSED &&
                property.propertyStatus !== PropertyStatus.OFF_MARKET,
            )
            .sort((a, b) => a.propertyCode.localeCompare(b.propertyCode))
            .map((property) => (
              <Fragment key={property.id}>
                <div className="row">
                  <div className="col-md-10 col-md-offset-1 text-center">
                    <Link
                      to={`https://assets.brickx.com/downloads/ADD_${renderCode(
                        property.propertyCode,
                      )}.pdf`}
                      target="_blank"
                      className="doc-download"
                    >
                      <div className="button orange-button right-arrow-button">
                        DOWNLOAD ADDITIONAL DISCLOSURE DOCUMENT -{' '}
                        {renderCode(property.propertyCode)}
                      </div>
                    </Link>
                  </div>
                </div>
                <br />
              </Fragment>
            ))}
          <div className="row">
            <div className="col-md-10 col-md-offset-1 text-center">
              <a
                href="/pds/latest-pds-updates"
                className="button orange-button right-arrow-button"
              >
                RG45/RG46/RG240 SCHEDULE & OTHER DOCUMENTS
              </a>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
    );
  }
}
